import { Injectable } from '@angular/core';
import { CanActivate } from '@angular/router';
import { Observable } from 'rxjs';
import { filter } from 'rxjs/operators';
import { PermissionService } from './permission.service';

@Injectable({
    providedIn: 'root',
})
export class AuthGuardService implements CanActivate {
    constructor(private permissionService: PermissionService) {}

    public canActivate(): Observable<boolean> | Promise<boolean> | boolean {
        return this.permissionService.isUserAuthorized$.pipe(filter((s) => s !== undefined));
    }
}
